import { Component,Inject,OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { editCampaignModel, newCampaignModel } from 'src/app/models/campaign.model';
import { UserModel } from 'src/app/models/user.model';
import { MainService } from 'src/app/services/main.service';
import { UsersService } from 'src/app/services/users.service';
import { ProjectsService } from 'src/app/services/projects.service';
import Swal from 'sweetalert2';


@Component({
  selector: 'app-projects-campaign-add',
  templateUrl: './projects-campaign-add.component.html',
  styleUrls: ['./projects-campaign-add.component.scss']
})
export class ProjectsCampaignAddComponent implements OnInit {

  constructor(
    @Inject(MAT_DIALOG_DATA) public data : any,
    private projectsService : ProjectsService,
    private dialogRef: MatDialogRef<ProjectsCampaignAddComponent>,
    private main : MainService,
    private userS: UsersService
  ) {
    this.isEdit = this.data.edit;
    this.id_proj = this.data.id_proj;
    //this.id_world = this.data.id_world;
    if(this.isEdit){
      this.LoadCampaignData(this.data.data);

    }
   }

  isEdit : boolean = false;
  id_proj : number = 0;
  newCampaign : any;
  newDateTody : Date = new Date();
  minDate : Date = new Date();
  isClientUsr: boolean = false;
  deadline : Date = new Date();
  visibledeadline : boolean = false;
  companiesList : any;
  userObj!: UserModel;
  //id_world : number = 0

  ngOnInit(): void {
    this.userObj = this.userS.getUser();
    if(!this.isEdit){
    this.newCampaign = new newCampaignModel();
    this.newCampaign.name="";
    this.newCampaign.id_compania = 1;
    this.newDateTody.setDate(this.newDateTody.getDate() + 1);
    this.deadline = new Date(this.newDateTody);
    }
  }

  LoadCampaignData(camp : any){
    this.newCampaign = new editCampaignModel();
    this.newCampaign.id_camp = camp.id;
    this.newCampaign.name = camp.name;
    this.newCampaign.active = camp.active;
  }

  saveCampaign(){
    if(!this.isEdit){
      this.createCampaign();
    }else{
      this.editCampaign();
    }
  }

  createCampaign(){
    if(this.newCampaign.name!= "" && this.newCampaign.id_compania!= 0){
      this.main.ShowLoading();
      this.newCampaign.deadline = this.deadline.toISOString().slice(0, 10);
      this.newCampaign.id_proj = this.id_proj;
      //this.newCampaign.id_world = this.id_world;
      this.projectsService.newCampaign(this.newCampaign).subscribe(
        (result:any) => {
          this.main.HideLoading();
          if(result.message == "Success") {
            Swal.fire({
              icon: 'success',
              title: 'Creado',
              text: 'Proyecto creado correctamente'          
            }).then(() => {            
              this.dialogRef.close({ reload: true });
            });
          }
        },
        (err:any) => {
          this.main.HideLoading();
          console.log(err);
          Swal.fire({
            icon: 'error',
            title: 'Error al guardar',
            text: 'Ocurrió un error al guardar el registro, por favor vuelve a intentarlo.'
          });
        }
      );
      console.log(this.newCampaign);
    }else{
      Swal.fire({
        icon: 'error',
        title: 'Faltan datos',
        text: 'Por favor ingrese los datos requeridos'
      });
    }
  }

  
  editCampaign(){
    if(this.newCampaign.name!= ""){
      this.main.ShowLoading();
      this.projectsService.editCampaign(this.newCampaign).subscribe(
        (result:any) => {
          this.main.HideLoading();
          if(result.message == "Success") {
            Swal.fire({
              icon: 'success',
              title: 'Editado',
              text: 'Proyecto editado correctamente'          
            }).then(() => {            
              this.dialogRef.close({ reload: true });
            });
          }
        },
        (err:any) => {
          this.main.HideLoading();
          if(err.error.message != "No changes detected or no valid campaigns were found in the request") {
            Swal.fire({
              icon: 'error',
              title: 'Error al guardar',
              text: 'Ocurrió un error al guardar el registro, por favor vuelve a intentarlo.'
            });
          }
        }
      );
    }else{
      Swal.fire({
        icon: 'error',
        title: 'No hay nombre de proyecto',
        text: 'Por favor ingrese un nombre válido'
      });
    }
  }

}
